<template>
  <div class="vx-row">
    <vs-card>
      <vs-collapse>
        <vs-collapse-item>
          <div slot="header" class="font-bold">Rapport - Succès</div>
          <div class="vx-row">
            <div class="data-list-container">
              <vs-table ref="table" max-items="10" :data="success_data">
                <template slot="thead">
                  <vs-th>Ligne</vs-th>
                  <vs-th>Code contrat</vs-th>
                  <vs-th>Nom client</vs-th>
                  <vs-th>Téléphone</vs-th>
                  <vs-th>Email</vs-th>
                  <vs-th>Segment</vs-th>
                  <vs-th>Commercial</vs-th>
                  <vs-th>Adresse</vs-th>
                </template>

                <!-- DATA -->
                <template slot-scope="{ data }">
                  <tbody ref="tbody">
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td>{{ tr.line }}</vs-td>
                      <vs-td>{{ tr.account_code }}</vs-td>
                      <vs-td>{{ tr.social_reason }}</vs-td>
                      <vs-td>{{ tr.phone }}</vs-td>
                      <vs-td>{{ tr.email }}</vs-td>
                      <vs-td>{{ tr.segment }}</vs-td>
                      <vs-td>{{ tr.commercial }}</vs-td>
                      <vs-td>{{ tr.address }}</vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-collapse-item>
        <vs-collapse-item>
          <div slot="header" class="font-bold">Rapport - Erreur</div>
          <div class="vx-row">
            <div class="data-list-container">
              <vs-table ref="table" max-items="10" :data="wrong_data">
                <template slot="thead">
                  <vs-th>Ligne</vs-th>
                  <vs-th>Code contrat</vs-th>
                  <vs-th>Nom client</vs-th>
                  <vs-th>Téléphone</vs-th>
                  <vs-th>Email</vs-th>
                  <vs-th>Segment</vs-th>
                  <vs-th>Commercial</vs-th>
                  <vs-th>Adresse</vs-th>
                  <vs-th>Raison de l'échec</vs-th>
                </template>

                <!-- DATA -->
                <template slot-scope="{ data }">
                  <tbody ref="tbody">
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td>{{ tr.line }}</vs-td>
                      <vs-td>{{ tr.account_code }}</vs-td>
                      <vs-td>{{ tr.social_reason }}</vs-td>
                      <vs-td>{{ tr.phone }}</vs-td>
                      <vs-td>{{ tr.email }}</vs-td>
                      <vs-td>{{ tr.segment }}</vs-td>
                      <vs-td>{{ tr.commercial }}</vs-td>
                      <vs-td>{{ tr.address }}</vs-td>
                      <vs-td>{{ tr.reason }}</vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-collapse-item>
      </vs-collapse>
    </vs-card>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    success_data: [],
    wrong_data: [],
  }),
  methods: {
    loadHistory() {
      this.$vs.loading();
      let id = this.$route.params.id;
      this.$http
        .get("/customers/upload/upload-history/" + id)
        .then((response) => {
          let infos = response.data;
          this.success_data = JSON.parse(infos.success_data);
          this.wrong_data = JSON.parse(infos.wrong_data);

          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    this.loadHistory();
  },
};
</script>

<style>
</style>
